import { notNil } from './helpers';

/**
 * Check if the iterable is not empty
 * @param value - The value to check
 */
export function notEmpty<T extends Iterable<any>>(value: T) {
  return notNil(value) && value[Symbol.iterator]().next().done === false;
}
